import {DaoGeneric} from "@Services/base/daoService";
import {PopulationEnum} from "./enums/population.enum";
import {map} from "rxjs/operators";
import {Pagination} from "@Common/widgets/general/pagination";
import {of} from "rxjs";

export interface ListReference {
  id: number;
  label: string;
  description?: string;
  numero_emploi?: string;
  inm_mandatory?: boolean;
  visible_for_dvc?: boolean;

  population?: number;
  nb_dossiers?: number;

  dt_created?: string;
  dt_updated?: string;
}


/**
 * Obtient la liste d'éléments d'une liste référence (motivation, intitulé, caté, fondements jur.) selon la population
 * @param itemsSvc le service API pour le listAllItems
 * @param {ListReference} addFirstItem : si on doit ajouter un élément vide en 1er
 * @param {PopulationEnum} population : filtre sur la population souhaitée
 * @private
 * @return Promise<T>
 */
export async function getListReference(
  itemsSvc: DaoGeneric<ListReference>,
  population: PopulationEnum = PopulationEnum.aucun,
  addFirstItem: ListReference = null): Promise<ListReference[]> {

  let extraParams: Map<string, string> = null;

  if (population !== PopulationEnum.aucun) {
    extraParams  = new Map<string, string>();
    extraParams.set('by_population', population.toString());
    return await itemsSvc
      .listAllItems(extraParams, '', false)
      .pipe(map((data: Pagination) => { return addFirstItem ? [addFirstItem, ...data.list] : data.list; }))
      .toPromise();
  }

  return await of([]).toPromise();
}
